import React, { useState, useEffect } from 'react';
import { POPUP_KEY_DELETE_PREFERENCE } from '../../constant';
import { popupOpenService } from '../../shared/popupOpenService';
import { PREFERENCE_URL, deleteFetchRequest } from '../../store/requests';
import { MODAL_SMALL_SIZE } from '../helper';
import Modal from '../Modal';
import { useTranslation } from 'react-i18next';
import { preferencesStorageInstance as preferencesStorage } from '../../services/preferencesStorage';
import {errorCallback, makeUrl} from "../../util";
import { Button } from '@chapche/ui';

const DeleteModalContent = ({ handleDelete, handleClose }) => {
    const { i18n } = useTranslation();
    return (
        <>
            <h2 className="modal__title modal__title_align block__title-h3 block__title-h3">{i18n.t('app.page.preference.modal.title')}</h2>
            <p className="block__content modal__text modal__text_align">{i18n.t('app.page.preference.modal.content')}</p>
            <div className="modal__button-group">
                <Button variant="outline" onClick={() => handleClose(null)}>{i18n.t('app.page.preference.modal.cancel')}</Button>
                <Button onClick={handleDelete}>{i18n.t('app.page.preference.modal.delete')}</Button>
            </div>
        </>
    );
};

const DeletePreferencePopup = ({ notifyPreferencesList }) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleOpenModal = () => {
        setIsOpen(true);
    };    
    
    useEffect(() => {
        popupOpenService.registerPopup(POPUP_KEY_DELETE_PREFERENCE, handleOpenModal);
        return () => popupOpenService.unRegisterPopup(POPUP_KEY_DELETE_PREFERENCE, handleOpenModal);
    },[]);

    const deletePreference = () => {        
        setIsOpen(null);
        for(let preference of preferencesStorage.getSelectedPreferencesList()) {
            deleteFetchRequest(makeUrl([PREFERENCE_URL, preference.id, '/']), () => notifyPreferencesList(), errorCallback);
        }
        preferencesStorage.cleanSelectedPreferences();
    };

    return (
        isOpen ?
            <Modal content={<DeleteModalContent handleClose={setIsOpen} handleDelete={deletePreference} />} 
                handleCloseModal={setIsOpen} size={MODAL_SMALL_SIZE}/>
            :
            null
    );
};

export default DeletePreferencePopup;
